module.exports = __webpack_public_path__ + "static/preview-ufo-15bd24cb7d5113980f4c7035208ea8a7.png";